import React from "react";
import "../index.css";
import "../theme-login-style.css";

import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Form,
  Input,
  Image,
  message,
  Modal,
  Spin,
  Switch,
  QRCode,
} from "antd";
import withRouter from "../withRouter";
import { postApi } from "./Utility";
import { encode as base64_encode } from "base-64";
import Cookies from "universal-cookie";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";

import UsersStore from "../store/UsersStore.js";

class Logout extends React.Component {
  constructor(props) {
    super(props);
   
    this.cookies = new Cookies();
    this.UsersStore = new UsersStore();
  }
  async componentDidMount() {
    const userId  = this.props.getUserData().userId;
    const res = await this.UsersStore.logout(userId);
    if(res.success=='S'){
        this.cookies.remove("isAdmin");
        this.props.removeCookie("data");
        this.props.navigate("/login");  
    }
  }
  render() {
    return <div>Hello</div>;
  }

  
}

Logout.contextType = StoreContext;
export default observer(withRouter(Logout));
